export type UpdatedTask = { id: string, decision: string, comment: string, decisionReason: DecisionReason|null };

export type DecisionReason = { id: number}

export enum UpdateReviewTaskActions {
    BatchSubmitDecisionsRequest = "BatchSubmitDecisionsRequest",
    BatchSaveDecisionsRequest = "BatchSaveDecisionsRequest",
    BatchClearDecisionsRequest = "BatchClearDecisionsRequest",
    BatchTasksReassignmentRequest = "BatchTasksReassignmentRequest"
}

interface UpdateReviewTasks {
    data: Array<UpdatedTask>
    reviewId: string
    action: UpdateReviewTaskActions
}

export class SubmitReviewTasks implements UpdateReviewTasks {
    action: UpdateReviewTaskActions = UpdateReviewTaskActions.BatchSubmitDecisionsRequest
    data: Array<UpdatedTask>;
    reviewId: string;

    constructor(data: Array<UpdatedTask>, reviewId: string) {
        this.data = data
        this.reviewId = reviewId
    }
}

export class SaveReviewTasks implements UpdateReviewTasks {
    action: UpdateReviewTaskActions = UpdateReviewTaskActions.BatchSaveDecisionsRequest
    data: Array<UpdatedTask>;
    reviewId: string;

    constructor(data: Array<UpdatedTask>, reviewId: string) {
        this.data = data
        this.reviewId = reviewId
    }
}